import { Group, List, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import Dates from 'components/Dates';
import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { IDetailSchool } from 'types/dacum/schoolManagement';

interface DetailSchoolSectionProps {
  data: IDetailSchool;
}

const DetailSchoolSection: React.FC<DetailSchoolSectionProps> = ({ data }) => {
  const labelMapping: Record<keyof IDetailSchool, string> = {
    msSchoolCompetencyManagementID: 'School Competency Management ID',
    schoolName: 'School Names',
    businessUnitID: 'Business Unit ID',
    description: 'Description',
    notes: 'Notes',
    dateIn: 'Date Created',
    dateUp: 'Date Updated',
    userIn: 'Created By',
    userUp: 'Updated By',
    businessUnitName: 'Business Unit Name',
    jobFamilies: 'Job Families',
    jobFamilyGroupName: 'Job Family Group',
    jobFamilyGroupID: 'Job Family Group ID'
  };

  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineDocumentText />
          <Text c={'dark'} fw={700}>
            Detail Information
          </Text>
        </Group>

        {Object.keys(data).map((key, index) => {
          if (key === 'dateIn' || key === 'dateUp') {
            return (
              <Stack gap={0} key={index}>
                <Text c={'dark'} fw={600} fz={14}>
                  {labelMapping[key as keyof typeof labelMapping]}
                </Text>
                <Dates date={String(data[key as keyof IDetailSchool])} dateFormat='dateNameTime' />
              </Stack>
            );
          }

          if (key === 'jobFamilies') {
            return (
              <Stack gap={0} key={index}>
                <Text c={'dark'} fw={600} fz={14}>
                  {labelMapping[key as keyof typeof labelMapping]}
                </Text>
                <List>
                  {data['jobFamilies'].map((item, i) => {
                    return (
                      <List.Item fz={14} c={'secondary'} key={i}>
                        {item.jobFamilyName || '-'}
                      </List.Item>
                    );
                  })}
                </List>
              </Stack>
            );
          }

          return (
            <Stack gap={0} key={index}>
              <Text c={'dark'} fw={600} fz={14}>
                {labelMapping[key as keyof typeof labelMapping]}
              </Text>
              <Text fz={14} c={'secondary'}>
                {data[key as keyof IDetailSchool] != null
                  ? String(data[key as keyof IDetailSchool])
                  : '-'}
              </Text>
            </Stack>
          );
        })}
      </Stack>
    </Card>
  );
};

export default DetailSchoolSection;
